package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.Serializable
import kotlinx.serialization.SerialName

@Serializable
data class DashboardAnalyticsResponse(
    val timestamp: String = "",
    val scope: String = "",
    val metrics: DashboardAnalyticsMetrics = DashboardAnalyticsMetrics()
)

@Serializable
data class DashboardSchoolsAnalyticsResponse(
    val timestamp: String = "",
    val scope: String = "",
    @SerialName("total_schools")
    val legacyTotalSchools: Int? = null,
    val metrics: DashboardSchoolsAnalyticsMetrics = DashboardSchoolsAnalyticsMetrics()
) {
    val totalSchools: Int
        get() = metrics.totalRegisteredSchools.takeIf { it > 0 } ?: legacyTotalSchools ?: 0
}

@Serializable
data class DashboardSchoolsAnalyticsMetrics(
    @SerialName("total_registered_schools")
    val totalRegisteredSchools: Int = 0,
    @SerialName("active_schools")
    val activeSchools: Int = 0,
    @SerialName("suspended_or_inactive_schools")
    val suspendedOrInactiveSchools: Int = 0,
    @SerialName("deleted_schools")
    val deletedSchools: Int = 0
)

@Serializable
data class DashboardAnalyticsMetrics(
    val staff: DashboardAnalyticsStaffMetrics = DashboardAnalyticsStaffMetrics(),
    val students: DashboardAnalyticsStudentMetrics = DashboardAnalyticsStudentMetrics(),
    val parents: DashboardAnalyticsParentMetrics = DashboardAnalyticsParentMetrics(),
    @SerialName("it_users")
    val itUsers: DashboardAnalyticsItUserMetrics = DashboardAnalyticsItUserMetrics()
)

@Serializable
data class DashboardAnalyticsStaffMetrics(
    @SerialName("total_teachers")
    val totalTeachers: Int = 0,
    @SerialName("total_support_staff")
    val totalSupportStaff: Int = 0
)

@Serializable
data class DashboardAnalyticsStudentMetrics(
    @SerialName("total")
    val total: Int = 0,
    @SerialName("boys")
    val boys: Int = 0,
    @SerialName("girls")
    val girls: Int = 0
)

@Serializable
data class DashboardAnalyticsParentMetrics(
    @SerialName("total")
    val total: Int = 0,
    @SerialName("primary_contacts")
    val primaryContacts: Int = 0,
    @SerialName("secondary_contacts")
    val secondaryContacts: Int = 0
)

@Serializable
data class DashboardAnalyticsItUserMetrics(
    @SerialName("total")
    val total: Int = 0,
    @SerialName("active")
    val active: Int = 0,
    @SerialName("inactive")
    val inactive: Int = 0,
    @SerialName("deleted")
    val deleted: Int = 0
)
